import { motion } from "framer-motion";
import { Mail } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1611095790444-1dfa35e37b52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxyZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBjbGllbnQlMjBtZWV0aW5nfGVufDB8fHx8MTc5MDQ3NzIxM3ww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-28 bg-[#0D1220]">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-[1.05fr_0.95fr] gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight leading-tight">
            About iVIBES Consulting
          </h2>
          <p className="mt-6 text-lg text-slate-200 leading-relaxed">
            iVIBES Consulting helps real estate agents, teams, and brokers improve the systems
            that drive growth. We look at how leads are captured, how prospects are followed up
            with, how work gets done, and where technology can remove friction.
          </p>
          <p className="mt-5 text-lg text-slate-200 leading-relaxed">
            We begin with the business problem, not the software.
          </p>
          <p className="mt-5 text-lg text-slate-200 leading-relaxed">
            Our work may include strategy, process improvement, automation, AI, data, or
            technology — but every recommendation is chosen because it supports a measurable
            business outcome.
          </p>
          <div className="mt-10 rounded-2xl border border-white/10 bg-white/[0.03] p-6 flex flex-col sm:flex-row sm:items-center gap-6">
            <div className="h-14 w-14 shrink-0 rounded-full bg-gradient-to-br from-cyan-500 to-indigo-600 flex items-center justify-center font-heading font-bold text-lg">
              IA
            </div>
            <div>
              <p data-testid="about-founder-name" className="font-heading font-bold text-lg text-white">
                Ismail Abdur-Rahman
              </p>
              <p className="text-slate-300 text-sm mt-0.5">
                Founder &amp; Principal Business Systems Architect
              </p>
              <a
                href="mailto:ismail@ivibesconsulting.com"
                data-testid="about-email-link"
                data-track="email_click_about"
                className="mt-2 inline-flex items-center gap-2 text-cyan-300 text-sm font-semibold hover:text-cyan-200 transition-colors duration-200"
              >
                <Mail size={15} />
                ismail@ivibesconsulting.com
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          data-testid="about-visual"
          className="relative max-w-md mx-auto w-full lg:max-w-none"
        >
          <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-[0_32px_80px_rgba(0,0,0,0.5)]">
            <img
              src={ABOUT_IMG}
              alt="Real estate professional consulting with clients about their next move"
              loading="lazy"
              className="h-[340px] sm:h-[420px] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D1220] via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 rounded-xl border border-white/10 bg-[#0D1220]/85 backdrop-blur-md px-4 py-3">
              <p className="text-sm font-semibold text-white leading-snug">
                A growth partner for your pipeline — not another piece of software.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
